import { render, staticRenderFns } from "./Offline.vue?vue&type=template&id=1885270c&scoped=true&"
import script from "./Offline.vue?vue&type=script&lang=js&"
export * from "./Offline.vue?vue&type=script&lang=js&"
import style0 from "./Offline.vue?vue&type=style&index=0&id=1885270c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1885270c",
  null
  
)

/* vuetify-loader */
import installComponents from "!../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMain } from 'vuetify/lib/components/VMain';
installComponents(component, {VApp,VBtn,VContainer,VIcon,VMain})


/* hot reload */
if (module.hot) {
  var api = require("D:\\Users\\Jatin\\Documents\\Source\\wiom-dashboard\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1885270c')) {
      api.createRecord('1885270c', component.options)
    } else {
      api.reload('1885270c', component.options)
    }
    module.hot.accept("./Offline.vue?vue&type=template&id=1885270c&scoped=true&", function () {
      api.rerender('1885270c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Offline.vue"
export default component.exports